import { Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { DataTable } from '@/shared/components/data-table';
import type { Sku } from '../../types';
import type { SkuColumnDef, SkuRenderContext } from '../../hooks/useSkuListTable';

interface SkuListViewProps {
  sortedSkus: Sku[];
  visibleColumns: SkuColumnDef[];
  columnFilters: Record<string, string>;
  ctx: SkuRenderContext;
  sortKey: string;
  sortDirection: 1 | -1;
  isLoading: boolean;
  onSort: (key: string) => void;
  onSetColumnFilter: (key: string, value: string) => void;
  onSelectSku: (sku: Sku) => void;
  onCreateSku: () => void;
}

export function SkuListView({
  sortedSkus,
  visibleColumns,
  columnFilters,
  ctx,
  sortKey,
  sortDirection,
  isLoading,
  onSort,
  onSetColumnFilter,
  onSelectSku,
  onCreateSku,
}: SkuListViewProps) {
  return (
    <DataTable<Sku, SkuRenderContext>
      items={sortedSkus}
      columns={visibleColumns}
      ctx={ctx}
      columnFilters={columnFilters}
      sortKey={sortKey}
      sortDirection={sortDirection}
      onSort={onSort}
      onSetColumnFilter={onSetColumnFilter}
      onRowClick={onSelectSku}
      isLoading={isLoading}
      emptyState={
        <div className="py-8 text-center text-muted-foreground space-y-3">
          <p>No SKUs match your filters.</p>
          <Button variant="outline" size="sm" onClick={onCreateSku}>
            <Plus className="h-4 w-4 mr-1" /> Add SKU
          </Button>
        </div>
      }
    />
  );
}
